/* =========================================================
   Dolls In Love — zweite Altersverifizierung
   Gemeinsam genutzt von Galerie und Produktseite.
   Freizügige Aufnahmen bleiben unscharf, bis die Prüfung bestanden ist.
   ========================================================= */
(function () {
  'use strict';
  const KEY = 'dil_age_verified';
  const $ = (s, c) => (c || document).querySelector(s);

  let frei = false;
  try { frei = localStorage.getItem(KEY) === '1'; } catch (e) {}

  const hoerer = [];
  const modal = $('#verify');

  function oeffne() {
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(() => modal.classList.add('is-in'), 10);
  }
  function schliesse() {
    if (!modal) return;
    modal.classList.remove('is-in');
    document.body.style.overflow = '';
    setTimeout(() => { modal.hidden = true; }, 400);
  }

  if (modal) {
    const zu = $('#verifyClose');
    if (zu) zu.addEventListener('click', schliesse);
    modal.addEventListener('click', e => { if (e.target === modal) schliesse(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !modal.hidden) schliesse(); });

    const form = $('#verifyForm');
    if (form) form.addEventListener('submit', e => {
      e.preventDefault();
      const f = e.target;
      if (!f.name.value.trim() || !f.street.value.trim() || !f.zip.value.trim() || !f.dob.value || !f.ok.checked) {
        if (f.reportValidity) f.reportValidity();
        return;
      }
      const geb = new Date(f.dob.value);
      const volljaehrig = (Date.now() - geb.getTime()) / 31557600000 >= 18;

      form.hidden = true;
      $('#verifyState').hidden = false;
      $('#verifyStateText').textContent = 'Angaben werden geprüft …';

      setTimeout(() => {
        if (!volljaehrig) {
          $('#verifyState').classList.add('is-fail');
          $('#verifyStateText').textContent = 'Die Prüfung ergab keine Volljährigkeit. Die Aufnahmen bleiben gesperrt.';
          return;
        }
        $('#verifyState').classList.add('is-ok');
        $('#verifyStateText').textContent = 'Bestätigt — die Aufnahmen sind jetzt freigegeben.';
        frei = true;
        try { localStorage.setItem(KEY, '1'); } catch (e) {}
        hoerer.forEach(fn => { try { fn(); } catch (e) {} });
        setTimeout(schliesse, 1400);
      }, 1800);
    });
  }

  // Jeder Auslöser mit data-verify oeffnet die Prüfung
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-verify]');
    if (b) { e.preventDefault(); oeffne(); }
  });

  window.DIL_ALTER = {
    frei: () => frei,
    oeffne: oeffne,
    beiFreigabe: fn => hoerer.push(fn)
  };
})();
